<script setup lang="ts">
import { UiButton, UiText } from "@shopexperts/shared";

defineProps<{
    hasNextPage?: boolean;
    isFetchingNextPage?: boolean;
    isRefreshing?: boolean;
    label: string;
}>();

defineEmits<{
    (e: "load-more"): void;
}>();
</script>

<template>
    <div class="flex flex-col items-center gap-2 pt-2">
        <UiButton
            v-if="hasNextPage"
            variant="outline"
            :label="isFetchingNextPage ? 'Loading more...' : label"
            :disabled="isFetchingNextPage"
            @click="$emit('load-more')"
        />
        <UiText
            v-if="isRefreshing"
            as="p"
            variant="caption-normal"
            class="text-se-gray-500"
            text="Refreshing..."
        />
    </div>
</template>
